<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :append-to-body="true">
    <div class="device-select-dialog">
      <el-select 
        v-model="selectedDevice" 
        :placeholder="i18n.t('rfidwaitPleaseSelect')" 
        style="width: 100%"
        clearable
        filterable
      >
        <el-option
          v-for="device in deviceList"
          :key="device.code"
          :label="i18n.t(device.label)"
          :value="device.code"
        >
        </el-option>
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">{{i18n.t('cancel')  }}</el-button>
      <el-button type="primary" @click="onSubmit" :disabled="!selectedDevice">{{ i18n.t('enSure') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {i18n} from '@/api/i18n'
export default {
  data() {
    return {
      title: '',
      deviceList: [],
      selectedDevice: '',
      onSubmitCallback: null,
      onCancelCallback: null,
      dialogVisible: false,
      i18n
    }
  },
  methods: {
    open(title, deviceList, onSubmit, onCancel) {
      this.title = title || i18n.t('rfidwaitPleaseSelect')
      this.deviceList = deviceList
      this.selectedDevice = deviceList && deviceList.length > 0 ? deviceList[0].code : ''
      this.onSubmitCallback = onSubmit
      this.onCancelCallback = onCancel
      this.dialogVisible = true
    },
    onSubmit() {
      this.dialogVisible = false
      if (this.onSubmitCallback && this.selectedDevice) {
        const selectedDeviceObj = this.deviceList.find(device => device.code === this.selectedDevice)
        this.onSubmitCallback(selectedDeviceObj)
      }
    },
    onCancel() {
      this.dialogVisible = false
      this.selectedDevice = ''
      if (this.onCancelCallback) {
        this.onCancelCallback()
      }
    }
  }
}
</script>

<style scoped>

</style>